export const EIF_QUESTIONS_REQUEST = 'EIF_QUESTIONS_REQUEST'
export const EIF_QUESTIONS_SUCCESS = 'EIF_QUESTIONS_SUCCESS'
export const EIF_QUESTIONS_FAILURE = 'EIF_QUESTIONS_FAILURE'
export const EIF_QUESTIONS_UPDATE = 'EIF_QUESTIONS_UPDATE'

